import React from 'react';
import DownIcon from '@mui/icons-material/KeyboardArrowDownRounded';

interface ChevronToggleInterface {
  toggle: boolean;
  color?: string;
  className?: string;
  width?: number;
  height?: number;
}

export const ChevronToggle: React.FC<ChevronToggleInterface> = ({
  toggle,
  color = 'var(--icon-subdued)',
  className,
  width = 24,
  height = 24,
}) => {
  return (
    <DownIcon
      sx={{
        color,
        transform: toggle ? 'rotate(180deg)' : 'rotate(0deg)',
        transition: 'transform 200ms ease-in-out',
        width,
        height,
      }}
      className={className}
    />
  );
};
